import _ from 'lodash'
import { Controller, FieldValues } from 'react-hook-form'

import { FilterableListBox } from 'components/FilterableListBox'
import { CheckboxTree } from './CheckboxTree'

import type { CheckboxTreeFilterableProps } from './types'

export const CheckboxTreeFilterable = <T extends FieldValues>({
  control,
  disabled,
  name,
  options,
  placeholder,
}: CheckboxTreeFilterableProps<T>): React.JSX.Element => {
  if (_.isEmpty(options)) {
    return <></>
  }

  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <FilterableListBox
          {...{ disabled, placeholder }}
          width='max'
        >
          <CheckboxTree<T>
            {...{ disabled, field }}
            options={options as T}
          />
        </FilterableListBox>
      )}
    />
  )
}
